<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表-添加管理员
    -->
  <el-dialog title="添加客服" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">



    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
      
                
      <el-form-item label="照片：" prop="avatarUrl"  :label-width="formLabelWidth">
        <div class="draggable-list">
            <div v-if="form.avatarUrl">
                <div class="item">
                  <img v-img-url="form.avatarUrl" alt="file_path"/>
                  </div>
              </div>
          <div class="item img-select" @click="openProductUpload('avatarUrl')">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>

      
      
      <el-form-item label="客服姓名" prop="nickName" :rules="[{required: true,message: '姓名不能为空'}]">
        <el-input v-model="form.nickName" placeholder="请输入姓名"></el-input>
      </el-form-item>

      <el-form-item label="手机号码" prop="mobile" :rules="[{required: true,message: '手机号不能为空'}]">
        <el-input v-model="form.mobile" maxlength=11 placeholder="请输入手机号码"></el-input>
      </el-form-item>


      <el-form-item label="性别" prop="gender"  :label-width="formLabelWidth">
        <el-radio-group v-model="form.gender">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="0">女</el-radio>
        </el-radio-group>
      </el-form-item>


    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>

    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
  </el-dialog>
</template>

<script>
import UserApi from '@/api/user.js';
import Upload from '@/components/file/Upload';

export default {
  components: {
            /*图片上传*/
            Upload: Upload,
     
        },
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      /*form表单对象*/
      form: {
        nickName: '',
        access_id: [],
        // 会员到期时间设置
        expire_date_text: '',
        coordinate:"",
        address:"",
        gender:0,//0 女  1  男
      },
      /*form验证*/
      formRules: {
        nickName: [
          {
            required: true,
            message: '名字不能不为空',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号码不能为空',
            trigger: 'blur'
          }
        ],
      },
      // 会员到期时间选择器左侧快捷选项
      timePickerOpt: {
        shortcuts: [{
          text: '一年',
          onClick(picker) {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 1)
            picker.$emit('pick', date)
          }
        }, {
          text: '两年',
          onClick(picker) {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 2)
            picker.$emit('pick', date)
          }
        }, {
          text: '三年',
          onClick(picker) {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 3)
            picker.$emit('pick', date)
          }
        }]
      },
      isProductUpload:false,
    };
  },
  props: ['open', 'roleList','gradeList'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    }
  },
  created() {
    this.getRole();
  },
  methods: {
    /*选择的地址*/
    choseFunc(e){
                this.form.coordinate=e.location.lat+','+e.location.lng;
                this.form.address=e.address;
                this.$forceUpdate();
            },
            /*获取经纬度*/
            getMapdataFunc(e) {
                this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
                this.$forceUpdate();
            },  
           /*打开上传图片*/
           openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
   returnProductImgsFunc(e) {

        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

          var avatarUrl = e[0].file_path;
          this.form.avatarUrl = avatarUrl;
          this.$set(this.form, "avatarUrl", avatarUrl);
      }
   
      
      this.isProductUpload = false;
    },

    getRole(){
                let self = this

                let Params = {}

                UserApi.getRole(Params, true)
                    .then(data => {
                    self.rolearr = data.data
                    })
                    .catch(error => {

                    });
            },
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      self.$refs.form.validate((valid) => {
        if(valid){
            UserApi.adduser(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '添加成功',
              type: 'success'
            });
            this.form.nickName=''
            this.form.mobile=''
            this.form.grade_id=''
            self.dialogFormVisible(true);
          })
          .catch(error => {
            self.loading = false;
          });
        }if(!valid){
          self.loading = false;
        }

      });


    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style>

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

</style>



// WEBPACK FOOTER //
// src/views/service/index/part/add.vue